export function* range(count: number, start = 0): IterableIterator<number> {
  const end = start + count;
  for (let i = start; i < end; i++) {
    yield i;
  }
}
